<!-- En móvil (con botón de menú) no envuelve: el título se trunca y el logout queda en la misma línea. -->
<header
  class="flex min-h-12 shrink-0 items-center gap-2 border-b border-border-subtle bg-surface-card px-4 py-2 shadow-sm"
  [class.flex-wrap]="!showMenuButton()"
>
  @if (showMenuButton()) {
    <button
      #menuButton
      type="button"
      class="-ml-2 inline-flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-md text-text-muted transition hover:bg-surface-subtle hover:text-text-title focus:outline-none focus-visible:ring-2 focus-visible:ring-calypso-border"
      aria-label="Abrir menú"
      aria-haspopup="dialog"
      [attr.aria-expanded]="menuExpanded()"
      data-testid="header-menu-toggle"
      (click)="menuToggle.emit()"
    >
      <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </button>
  }

  @if (title()) {
    <h1 class="inline-flex min-w-0 items-center gap-2 text-lg font-bold tracking-tight text-text-title">
      <span class="truncate">{{ title() }}</span>
      @if (badge()) {
        <span
          class="inline-flex shrink-0 items-center rounded-full border border-calypso-border bg-calypso-light px-2 py-0.5 text-xs font-medium text-calypso-primary"
        >
          {{ badge() }}
        </span>
      }
    </h1>
  }

  @if (title() && description()) {
    <span class="text-gray-300" aria-hidden="true">|</span>
  }

  @if (description()) {
    <p class="truncate text-sm text-text-muted">{{ description() }}</p>
  }

  <div class="ml-auto flex items-center">
    <ng-content select="[headerActions]" />
  </div>

  <button
    type="button"
    class="group relative inline-flex h-8 w-8 shrink-0 items-center justify-center cursor-pointer rounded-md text-error transition hover:bg-calypso-light hover:text-calypso-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-calypso-border"
    aria-label="Cerrar sesión"
    data-testid="header-logout"
    (click)="logout.emit()"
  >
    <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
      />
    </svg>
    <span
      class="pointer-events-none absolute top-full right-0 z-50 mt-1 whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs font-medium text-white opacity-0 shadow transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100"
      aria-hidden="true"
    >
      Cerrar sesión
    </span>
  </button>
</header>
